import { render, staticRenderFns } from "./CommentsRecipe.vue?vue&type=template&id=00f0e975&scoped=true"
import script from "./CommentsRecipe.vue?vue&type=script&lang=js"
export * from "./CommentsRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f0e975",
  null
  
)

export default component.exports